/* eslint-disable no-useless-escape */

export function isObject (obj) {
  let type = typeof obj;
  return type === 'function' || (type === 'object' && !!obj);
}
export function dataURLtoFile (dataurl, filename = 'file') {
  let arr = dataurl.split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let suffix = mime.split('/')[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], `${filename}.${suffix}`, { type: mime })
}

/*
* 手机号码验证
* @param {String} phone
* @return {Boolean}
*/
export function checkPhone (phone) {
  const phoneReg = /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/
  if (!!phone && !phoneReg.test(phone)) {
    return false
  }
  return true
}
/*
* 邮箱验证
* @param {String} email
* @return {Boolean}
*/
//
export function checkEmail (email) {
  const emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return emailReg.test(email);
}
/**
 * 返回日期的指定格式
 * @param {any} fmt 'yyyy-MM-dd hh:mm:ss'
 * @param {any} date Date对象
 * @returns 'yyyy-MM-dd hh:mm:ss'格式的时间
 */
export function DateFtt (fmt, date) {
  let o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }

  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

export function formatNumber (n) {
  const str = n.toString();
  return str[1] ? str : `0${str}`;
}
export function formatTime (date) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();

  const t1 = [year, month, day].map(formatNumber).join('-');
  const t2 = [hour, minute, second].map(formatNumber).join(':');

  return `${t1} ${t2}`;
}
/*
  发送验证码后按钮变不可点击状态 API 封装
  调用前需要bind(this) 跟传递定时器handle参数
  调用方法如下 changeButton.bind(this)(handle)
*/
export function changeButton (time) {
  let handle = null
  if (time === 0) {
    this.handleTime = 60
    handle = setInterval(() => {
      this.handleTime = this.handleTime - 1
      if (this.handleTime === 0) {
        clearInterval(handle)
        handle = null
      }
    }, 1000)
  }
  return handle
}
